export const MODAL_NONE = 'MODAL_NONE';

export const MODAL_INFO = 'MODAL_INFO';
